import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
    NgbDate,
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter } from './ngbd-datepicker.adapter';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'ed-datepicker',
    templateUrl: './ed-datepicker.component.html',
    standalone: true,
    imports: [CommonModule, NgbDatepickerModule, FormsModule],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        DatePipe,
    ],
})
export class EdDatepickerComponent {
    @Input() date?: Date;
    @Input() disabled: boolean = false;
    @Output() dateChange = new EventEmitter<Date>();

    onDateChanged(selectedDate: string) {
        const newDate = new Date(selectedDate);
        this.dateChange.emit(newDate);
    }
}
